import { Select as AntSelect } from "antd";
import styled from "styled-components";
import React from "react";

const Styled = styled(AntSelect)`
  height: 5.5rem;
  .ant-select {
    &-selector {
      background-color: ${(_) => _.theme.token.surface.primary} !important;
      border: none !important;
      box-shadow: none !important;
      border-radius: 2rem !important;
      padding: 0 !important;
      padding-left: 1.5rem !important;
    }
    &-arrow {
      color: black;
      inset-inline-end: 1.5rem;
    }
    &-selection-placeholder {
      font-weight: 300 !important;
      line-height: 1.9rem;
    }
  }
`;

const Select = ({ ...props }) => {
  return <Styled dropdownStyle={{ borderRadius: 0 }} {...props} />;
};

export default Select;
